import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import EscalaSessao from '../../elements/EscalaSessao'
import NovosPacientesCard from '../../elements/NovosPacientesCard'
// import EscalaLivre from '../../elements/EscalaLivre' // Comentado - pode ser necessário voltar depois
import Aniversariantesdomes from '../../elements/Aniversariantesdomes'
import Contatoservicos from '../../elements/Contatoservicos'
import ListaAvisos from '../../elements/ListaAvisos'
import Ferias from '../../elements/Ferias'
import Footer from '../../components/Footer'
import { useNotification } from '../../contexts/NotificationContext';
import { authFetch } from '../../utils/authFetch';

const Home = () => {
    const navigate = useNavigate();
    const abortController = useRef(null);
    const [qtdePacienteAtivos, setQtdePacienteAtivos] = useState(0);
    const [qtdePacienteAvaliacao, setQtdePacienteAvaliacao] = useState(0);
    const [pacientesPorModalidade, setPacientesPorModalidade] = useState({
        scerts: 0,
        cce: 0,
        precoce: 0
    });
    const [novosPacientes, setNovosPacientes] = useState(0);
    const { showNotification } = useNotification();

    useEffect(() => {
        // Criar um novo AbortController para este ciclo
        abortController.current = new AbortController();

        const fetchSupCards = async () => {
            try {
                // Buscar dados do dashboard
                const response = await authFetch('dashboard/patient', {
                    method: "GET",
                    signal: abortController.current.signal
                });

                if (!response.ok) {
                    throw new Error("Erro ao buscar dados cards superiores");
                }

                const data = await response.json();
                setQtdePacienteAtivos(data.activePatients || 0);
                setQtdePacienteAvaliacao(data.patientsInAssessment || 0);
                setNovosPacientes(data.newPatients || 0);
                setPacientesPorModalidade({
                    scerts: data.scertsPatients || 0,
                    cce: data.ccePatients || 0,
                    precoce: data.precocePatients || 0
                });
            } catch (error) {
                // Não mostrar erro se a requisição foi cancelada
                if (error.name === 'AbortError') {
                    return;
                }
                showNotification("danger", "Erro ao carregar dados cards superiores");
            }
        };

        fetchSupCards();

        // Cleanup: aborta a requisição quando o componente for desmontado
        return () => {
            if (abortController.current) {
                abortController.current.abort();
            }
        };
    }, [showNotification]);


    const statusCards = [
        {
            key: 'ativos',
            label: 'Ativos',
            value: qtdePacienteAtivos,
            onClick: () => navigate('/Pacientes?status=0')
        },
        {
            key: 'avaliacao',
            label: 'Em Avaliação',
            value: qtdePacienteAvaliacao,
            onClick: () => navigate('/Pacientes?status=1')
        },
        {
            key: 'novos',
            label: 'Novos',
            value: novosPacientes,
            onClick: () => navigate('/Pacientes?filter=novos')
        }
    ];

    const modalityCards = [
        {
            key: 'scerts',
            label: 'SCERTS',
            value: pacientesPorModalidade.scerts,
            onClick: () => navigate('/Pacientes?modality=SCERTS&enabledOnly=true'),
            background: 'rgba(229, 151, 64, 0.3)'
        },
        {
            key: 'cce',
            label: 'CCE',
            value: pacientesPorModalidade.cce,
            onClick: () => navigate('/Pacientes?modality=CCE&enabledOnly=true'),
            background: 'rgba(219, 111, 70, 0.3)'
        },
        {
            key: 'precoce',
            label: 'Precoce',
            value: pacientesPorModalidade.precoce,
            onClick: () => navigate('/Pacientes?modality=PRECOCE&enabledOnly=true'),
            background: 'rgba(86, 153, 105, 0.3)'
        }
    ];

    return (
        <div>
            <div className="container-fluid py-4">
                <div className="row">
                    {/* Card Pacientes */}
                    <div className="col-12">
                        <div className="card" style={{ border: '1px solid #dee2e6' }}>
                            <div className="card-header pb-0 text-center">
                                <h6 className="mb-2 font-weight-bolder" style={{ marginBottom: '0.75rem' }}>Pacientes</h6>
                            </div>
                            <div className="card-body p-3">
                                <div className="row g-3">
                                    {/* Coluna Status */}
                                    <div className="col-lg-6">
                                        <div className="d-flex align-items-center mb-3">
                                            <div style={{ flex: 1, height: '1px', backgroundColor: '#dee2e6' }}></div>
                                            <h6 className="text-uppercase text-secondary text-xs font-weight-bolder mx-3 mb-0">Status</h6>
                                            <div style={{ flex: 1, height: '1px', backgroundColor: '#dee2e6' }}></div>
                                        </div>
                                        <div className="row g-3">
                                            {statusCards.map((card) => (
                                                <div key={card.key} className="col-4">
                                                    <button
                                                        type="button"
                                                        className="card h-100 w-100"
                                                        style={{ 
                                                            border: '1px solid #e9ecef', 
                                                            backgroundColor: card.background || 'transparent',
                                                            minHeight: '120px', 
                                                            cursor: 'pointer' 
                                                        }}
                                                        onClick={card.onClick}
                                                    >
                                                        <div className="card-body p-3 d-flex flex-column justify-content-center align-items-center text-center">
                                                            <p className="text-sm mb-2 text-capitalize font-weight-bold mb-0" style={{ color: '#344767' }}>{card.label}</p>
                                                            <h4 className="font-weight-bolder mb-0" style={{ fontSize: '1.75rem', color: '#344767' }}>{card.value}</h4>
                                                        </div>
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {/* Coluna Modalidade */}
                                    <div className="col-lg-6">
                                        <div className="d-flex align-items-center mb-3">
                                            <div style={{ flex: 1, height: '1px', backgroundColor: '#dee2e6' }}></div>
                                            <h6 className="text-uppercase text-secondary text-xs font-weight-bolder mx-3 mb-0">Modalidade</h6>
                                            <div style={{ flex: 1, height: '1px', backgroundColor: '#dee2e6' }}></div>
                                        </div>
                                        <div className="row g-3">
                                            {modalityCards.map((card) => (
                                                <div key={card.key} className="col-4">
                                                    <button
                                                        type="button"
                                                        className="card h-100 w-100"
                                                        style={{ 
                                                            border: '1px solid #e9ecef', 
                                                            backgroundColor: card.background || 'transparent',
                                                            minHeight: '120px', 
                                                            cursor: 'pointer' 
                                                        }}
                                                        onClick={card.onClick}
                                                    >
                                                        <div className="card-body p-3 d-flex flex-column justify-content-center align-items-center text-center">
                                                            <p className="text-sm mb-2 text-capitalize font-weight-bold mb-0" style={{ color: '#344767' }}>{card.label}</p>
                                                            <h4 className="font-weight-bolder mb-0" style={{ fontSize: '1.75rem', color: '#344767' }}>{card.value}</h4>
                                                        </div>
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <EscalaSessao />
                </div>
                <div className="row mt-4">
                    <NovosPacientesCard />
                </div>
                <div className="row mt-4">
                    {/* <EscalaLivre /> Comentado - pode ser necessário voltar depois */}
                    <Aniversariantesdomes />
                    <Ferias />
                </div>

                <div className="row my-4">
                    <ListaAvisos />
                </div>

            </div>
            <Footer />
        </div>
    )
}

export default Home